import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import memoize from 'lodash/memoize';
import moment from 'moment';
import * as T from 'prop-types';


export const responseFieldViewpropTypes = {
  className: T.string,
  response: T.object.isRequired,
};

export const cachedFmtDate = memoize(fmtDate);
export const cachedFmtTime = memoize(fmtTime);

function fmtDate(date) {
  if (isNumber(date)) {
    return moment(date).format('MM-DD-YYYY');
  } else {
    return null;
  }
}

function fmtTime(date) {
  if (isNumber(date)) {
    return moment(date).format('HH:mm');
  } else {
    return null;
  }
}

export function getItemKey(result) {
  return get(result, 'id', null);
}

export function checkIsItemSelected(selectedValue, optionValue) {
  return getItemKey(selectedValue) === getItemKey(optionValue);
}



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/utils.js